import UserManagementMainTable from "@/components/UserManagementComponents/Tables/userManagementMainTable.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageUserManagementProps = {
  // TODO: add props here
};

const PageUserManagement: React.FC<PageUserManagementProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BasePage currPage="userManagement">
      <div className="h-full overflow-y-auto">
        <h2 className="mt-4 text-center text-2xl font-bold">
          Users Management
        </h2>
        <UserManagementMainTable />
      </div>
    </BasePage>
  );
};

export default PageUserManagement;
